let code = 'geoportalgestao';
let codeAPI = 'geoportal';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};
